const styles = ({ typography }) => ({
  label: {
    marginTop: typography.pxToRem(8),
    marginBottom: typography.pxToRem(16),
  },
});

export default styles;
